import { useTranslation } from "react-i18next";
import Modal, { SimpleModalControls } from "../../components/Modal";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { getAxiosInstance } from "../../utils/axiosInstance";
import { Button, Select } from "@chakra-ui/react";


type Provider  = {
    id: string,
    name: string,
    cui: string,
    address: string,
    phoneNumber: string,
    email: string,
    country: string,
    isDeleted: boolean
}

interface AddModalProviders extends SimpleModalControls {
  productId: string
}

const ModalAddProductProvider = (props: AddModalProviders) => {
    const { t } = useTranslation("translations");
    const [providers, setProviders] = useState<any>([]);
    const [providerId, setProviderId] = useState<string>("");

    const getProviders = async() => {
        try {
            const res = await getAxiosInstance().get(`/ProvidersNotAssociated/${props.productId}`);
            setProviders(res.data);

          } catch (error) {
            if (axios.isAxiosError(error)) {
              toast.error(`${error.response?.data}`, { position: toast.POSITION.BOTTOM_RIGHT })
            } else {
              toast.error(`Could now retrieve providers ${error}`, { position: toast.POSITION.BOTTOM_RIGHT });
            }
          }
    }

    const AddProductProvider = async() => {
        try {
            const res = await getAxiosInstance().post('/ProductProviders', {
              productId: props.productId,
              providerId: providerId,
            });
           
            if(res.status === 200){
              toast.success("Successfully attached a provider to a product", { position: toast.POSITION.BOTTOM_RIGHT });
              props.onClose();
            }

          } catch (error) {
            if (axios.isAxiosError(error)) {
              toast.error(`${error.response?.data}`, { position: toast.POSITION.BOTTOM_RIGHT })
            } else {
              toast.error(`Fields not filled out properly ${error}`, { position: toast.POSITION.BOTTOM_RIGHT });
            }
          }
    }

    const handleChange = (id: string) => {
      setProviderId(id);
    }

    useEffect(() => {
        getProviders();
    }, [])

    return(
        <>
            <Modal
                header={t("Add Providers for Product")}
                isOpen={props.isOpen}
                onClose={props.onClose}
                secondaryActionName={t("Save")}
                secondaryActionEnabled={true}
                secondaryAction={() => { AddProductProvider() }}
            >
        
            <Select placeholder='Select option' onChange={(e) => {handleChange(e.target.value)}}>
                {
                    providers.map((c:any, index: number) => {
                        return (
                        <option  key= {index} value={c.id}>{c.name}</option>
                        )
                    })
                }
            </Select>
            </Modal>
          
        </>
    )
}


export default ModalAddProductProvider;